import { render, staticRenderFns } from "./Paused.vue?vue&type=template&id=09976e88&scoped=true&"
import script from "./Paused.vue?vue&type=script&lang=js&"
export * from "./Paused.vue?vue&type=script&lang=js&"
import style0 from "./Paused.vue?vue&type=style&index=0&id=09976e88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09976e88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09976e88')) {
      api.createRecord('09976e88', component.options)
    } else {
      api.reload('09976e88', component.options)
    }
    module.hot.accept("./Paused.vue?vue&type=template&id=09976e88&scoped=true&", function () {
      api.rerender('09976e88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Paused.vue"
export default component.exports